module.exports = __webpack_public_path__ + "static/img/img6.d7e765f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/modeling/expression/img6.png
// module id = N8CK
// module chunks = 7